import { get } from 'lodash';
import moment from 'moment';

import {
    CREATE_SESSION_FAILURE,
    CREATE_SESSION_REQUEST,
    CREATE_SESSION_SUCCESS,
    EXTEND_SESSION_FAILURE,
    EXTEND_SESSION_REQUEST,
    EXTEND_SESSION_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT_REQUEST,
    SKIP_VALIDATION,
    VALIDATE_SESSION_FAILURE,
    VALIDATE_SESSION_REQUEST,
    VALIDATE_SESSION_SUCCESS,
} from './types/authentication-action-types';
import {
    clearCookie,
    clearJwtCookie,
} from '../../utils/cookie-utils';
import {
    getQueryParams
} from '../../utils/query-param-utils';
import { isInitialLoadSelector } from '../selectors/ui-state-selectors';
import AuthService from '../services/auth-service';

function loginFailure( error ){
    return {
        error,
        type: LOGIN_FAILURE,
    };
}
export function login( username ){
    return ( dispatch, getState, { END_USER_AUTH_API, END_USER_APP_ID } ) => {
        const redirectUrl = `${END_USER_AUTH_API}/v1/token?client_id=${END_USER_APP_ID}&user_email=${encodeURIComponent( username )}`;
        window.location.replace( redirectUrl );
    };
}

function validateSessionRequest(){
    return {
        type: VALIDATE_SESSION_REQUEST
    };
}

function validateSessionSuccess( userInfo ){
    if( userInfo.realmname ){
        userInfo.realmName = userInfo.realmname;
        delete userInfo.realmname;
    }
    return {
        type: VALIDATE_SESSION_SUCCESS,
        userInfo
    };
}

function validateSessionFailure( error ){
    return {
        error,
        type: VALIDATE_SESSION_FAILURE,
    };
}

function skipValidation(){
    return {
        type: SKIP_VALIDATION,
    };
}

export function validateSession(){
    return async( dispatch, getState, { AUTH_API, EIS_URL } ) => {
        dispatch( validateSessionRequest() );
        const authService = new AuthService( AUTH_API );

        try{
            let res = await authService.validate();

            const hasGlobalAccess = get( res, 'data.permissions', [] ).includes( 'EFD.GlobalAccess' );
            const hasRealm = get( res, 'data.realm', false );

            if( hasGlobalAccess && !hasRealm ){
                // if user is superuser but doesn't have a realm, send them back to super.php
                window.location.replace( `${EIS_URL}/super.php` );
            }
            else{
                dispatch( validateSessionSuccess( res.data ) );
            }

            if( sessionNeedsExtended( res.data ) ){
                dispatch( extendSessionRequest() );

                try{
                    await authService.extendSession();

                    dispatch( extendSessionSuccess() );
                }
                catch( err ){
                    return dispatch( extendSessionFailure( err.response ) );
                }
            }
        }
        catch( err ){
            return dispatch( validateSessionFailure( err.response ) );
        }
    };
}


function createSessionRequest(){
    return {
        type: CREATE_SESSION_REQUEST
    };
}
function createSessionSuccess( userInfo ){
    if( userInfo.realmname ){
        userInfo.realmName = userInfo.realmname;
        delete userInfo.realmname;
    }
    return {
        type: CREATE_SESSION_SUCCESS,
        userInfo
    };
}

function createSessionFailure( error ){
    return {
        error,
        type: CREATE_SESSION_FAILURE,
    };
}

export function createSession(){
    return async( dispatch, getState, { AUTH_API, EIS_URL, END_USER_AUTH_API } ) => {
        dispatch( createSessionRequest() );
        const state = getState();

        const notThisUser = getQueryParams().code === 'not_this_user';

        if( notThisUser ){
            clearCookie( 'login_email' );
            return dispatch( skipValidation() );
        }

        try{
            const authService = new AuthService( AUTH_API );
            await authService.createSession();

            let userDetails = await authService.getUserDetails();

            if( isInitialLoadSelector( state ) ){
                window.location.replace( EIS_URL );
            }
            else{
                dispatch( createSessionSuccess( userDetails.data ) );
            }

            if( sessionNeedsExtended( userDetails.data ) ){
                dispatch( extendSessionRequest() );

                try{
                    await authService.extendSession();

                    dispatch( extendSessionSuccess() );
                }
                catch( err ){
                    dispatch( extendSessionFailure( err.response ) );
                }
            }
        }
        catch( err ){
            if( document.referrer.split( '?' )[0] !== `${END_USER_AUTH_API}/v1/token/loggedout` ){
                dispatch( loginFailure( err.response ) );
            }
            dispatch( createSessionFailure( err.response ) );
        }
    };
}

function extendSessionRequest(){
    return {
        type: EXTEND_SESSION_REQUEST
    };
}

function extendSessionSuccess(){
    return {
        type: EXTEND_SESSION_SUCCESS
    };
}

function extendSessionFailure( error ){
    return {
        error,
        type: EXTEND_SESSION_FAILURE,
    };
}

function sessionNeedsExtended( tokenPayload ){
    let timeUntilExpire = tokenPayload.exp - moment().unix();
    let expireThreshold = ( tokenPayload.exp - tokenPayload.iat ) / 2;

    return timeUntilExpire <= expireThreshold;
}

function logoutRequest(){
    return {
        type: LOGOUT_REQUEST
    };
}

export function logout(){
    return ( dispatch, getState, { AUTH_API, USER_LOGOUT_URL } ) => {
        dispatch( logoutRequest() );
        clearJwtCookie();

        window.location.replace( USER_LOGOUT_URL );
    };
}
